import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'lodash';
// libraries
import $ from 'jquery';
import { Link } from 'react-router-dom';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { CircularProgress } from '@material-ui/core';
import CheckBoxes from '../generic_components/CheckBoxes';
import RadioButtons from '../generic_components/RadioButtons';
import ValidatedDropDown from '../generic_components/ValidatedDropDown';

import ProjectMatchingFormWorkFieldSelectionPopUp from './ProjectMatchingFormWorkFieldSelectionPopUp';

import * as CONSTANTS from '../constants';
import * as CONFIG from '../config';
import * as UTILS from '../utils/utilFunctions';
import TEXT_GENERAL from '../text';

const hierarchyCheckBoxOptions = [
  { key: 'CEO/MGL', label: 'CEO/Mitglied GL' },
  { key: 'Führungsposition', label: 'Führungsposition' },
  { key: 'Fachkader/Spezialist', label: 'Fachkader/Spezialist:in' },
  { key: 'Mitarbeiter', label: 'Mitarbeiter:in' },
  { key: 'Nachwuchskraft', label: 'Nachwuchskraft' }
];

const regionCheckBoxOptionsCandidate = [
  'Ganze Schweiz',
  'Zentralschweiz',
  'Zürich/SH',
  'Ostschweiz/GR/FL',
  'Mittelland',
  'Bern',
  'Basel',
  'Oberwallis',
  'Westschweiz',
  'Tessin',
  'Umzugsbereit'
];

const regionCheckBoxOptions = regionCheckBoxOptionsCandidate.filter(region => region !== 'Umzugsbereit');

const salaryCheckBoxOptionsProject = [
  { key: 70000, label: "<= 70'000.--" },
  { key: 100000, label: "<= 100'000.--" },
  { key: 130000, label: "<= 130'000.--" },
  { key: 160000, label: "<= 160'000.--" },
  { key: 190000, label: "<= 190'000.--" },
  { key: 220000, label: "<= 220'000.--" },
  { key: 250000, label: "<= 250'000.--" },
  { key: 280000, label: "<= 280'000.--" },
  { key: 310000, label: "<= 310'000.--" }
];

const salaryCheckBoxOptionsCandidate = [
  { key: 70000, label: ">= 70'000.--" },
  { key: 100000, label: ">= 100'000.--" },
  { key: 130000, label: ">= 130'000.--" },
  { key: 160000, label: ">= 160'000.--" },
  { key: 190000, label: ">= 190'000.--" },
  { key: 220000, label: ">= 220'000.--" },
  { key: 250000, label: ">= 250'000.--" },
  { key: 280000, label: ">= 280'000.--" },
  { key: 310000, label: ">= 310'000.--" }
];

/**
 * option only available in candidateView
 */
// const financialShareCheckBox = ['Interesse an finanzieller Beteiligung'];

const languageNameDropDownOptions = [
  '',
  'Deutsch',
  'Englisch',
  'Französisch',
  'Spanisch',
  'Italienisch',
  'Russisch',
  'Holländisch',
  'Afghanisch',
  'Afrikaans',
  'Ägyptisch',
  'Albanisch',
  'Alt Hebräisch',
  'Altgriechisch',
  'Amharisch',
  'Arabisch',
  'Armenisch',
  'Asarisch',
  'Aserbaidschanisch',
  'Assyrisch',
  'Äthiopisch',
  'Bamun',
  'Baskisch',
  'Bengalisch',
  'Birmanisch',
  'Bosnisch',
  'Brasilianisch',
  'Bulgarisch',
  'Cantonesisch',
  'Cebuano',
  'Chinesisch',
  'Dänisch',
  'Dari',
  'Elsässisch',
  'Esperanto',
  'Estnisch',
  'Farsi',
  'Finnisch',
  'Flämisch',
  'Gälisch',
  'Gebärdensprache',
  'Georgisch',
  'Griechisch',
  'Gujarati',
  'Haussa',
  'Hebräisch',
  'Hindu',
  'Indisch',
  'Indonesisch',
  'Irakisch',
  'Iranisch',
  'Irisch',
  'Isländisch',
  'Israelisch',
  'Iwrit',
  'Japanisch',
  'Kambodschanisch',
  'Kantonesisch',
  'Karatschaisch',
  'Kasachisch',
  'Katalanisch',
  'Khmer',
  'Kinyarwanda',
  'Kisuaheli',
  'Koreanisch',
  'Kroatisch',
  'Laotisch',
  'Latein',
  'Lettisch',
  'Litauisch',
  'Luxemburgisch',
  'Madegassisch',
  'Makedonisch',
  'Malayalam',
  'Malaysisch',
  'Mandarin',
  'Marokkanisch',
  'Mazedonisch',
  'Moldawisch',
  'Mongolisch',
  'Neu Hebräisch',
  'Neugriechisch',
  'Niederländisch',
  'Norwegisch',
  'Oromo',
  'Pakistanisch',
  'Paschtu',
  'Persisch',
  'Philippinisch',
  'Polnisch',
  'Portugiesisch',
  'Punjabi',
  'Putonhua',
  'Rumänisch',
  'Sanskrit',
  'Schwedisch',
  'Serbokroatisch',
  'Skandinavisch',
  'Slawisch',
  'Slowakisch',
  'Slowenisch',
  'Sorbisch',
  'Suaheli',
  'Swahili',
  'Syrisch',
  'Tadschikisch',
  'Tagalog',
  'Tamil',
  'Tartarisch',
  'Telugu',
  'Thai',
  'Tigrigna',
  'Tschechisch',
  'Tunesisch',
  'Türkisch',
  'Ukrainisch',
  'Ungarisch',
  'Urdu',
  'Urkainisch',
  'Usbekisch',
  'Vietnamesisch',
  'Weißrussisch',
  'Yoruba',
  'Zaghawa'
];

const languageSkillLevelDropDownOptions = [
  '',
  'Muttersprache / Dolmetscher (C2 - GERR)',
  'verhandlungssicher / fließend (C1 - GERR)',
  'sehr gute Kenntnisse (B2 - GERR)',
  'gute Kenntnisse (B1 - GERR)',
  'erweiterte Grundkenntnisse (A2 - GERR)',
  'Grundkenntnisse (A1 - GERR)',
  'Anfänger'
];

const sectorDropDownOptions = [
  '',
  // 'Alle',
  'Bank/Finanzinstitute Versicherungen',
  'Baugewerbe, Haupt-/Neben-/ Zulieferbranche',
  'Beratung',
  'Bildung',
  'Chemie/Pharma',
  'Dienstleistungen',
  'Energie/-produktion/-versorgung/-verteilung',
  'Gastgewerbe/Hotellerie',
  'Gesundheits-/Sozialwesen',
  'Gewerbe/Handwerk',
  'Handel',
  'Immobilien',
  'Industrie',
  'Informatik/Telekommunikation',
  'Konsum-/Luxusgüterindustrie',
  'Land-/Forstwirtschaft/Holz',
  'Medien/Druckerei/Verlage',
  'Medizinaltechnik',
  'Rechts-/Wirtschaftsberatung',
  'Tourismus/Reisen/Freizeit',
  'Transport/Logistik',
  'NPO/NGO/Verbände',
  'Öffentliche Verwaltung'
];

// helper functions
const removeEmptyStringsFromArray = originalArr => {
  let mappedArray = [];
  if (Array.isArray(originalArr)) mappedArray = originalArr.filter(entry => !!entry);
  return mappedArray;
};

const removeEmptyLanguageEntriesFromArray = originalArr => {
  let mappedArray = [];
  if (Array.isArray(originalArr)) mappedArray = originalArr.filter(entry => !!entry.languageName);
  return mappedArray;
};

class ProjectMatchingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFields: {
        showLoadingIndicator: false,
        hierarchy: props.data.hierarchy ? [...props.data.hierarchy] : [''],
        region: [...(props.data.region || []), ...(props.data.willingToMove === true ? ['Umzugsbereit'] : [])],
        salary: this.getInitialSalaryKey(),
        languageSkills: props.data.languageSkills
          ? [...props.data.languageSkills, { languageName: '', languageLevel: '' }]
          : [{ languageName: '', languageLevel: '' }],
        workFields: props.data.workFields || [],
        sector: props.data.sector ? [...props.data.sector, ''] : [''],
        partTimeFrom: defaultTo(props.data.partTimeFrom, this.props.inCandiateArchive ? '' : '100'), // TODO  0 == false :D
        partTimeTill: props.data.partTimeTill ? props.data.partTimeTill : props.data.workload,
        interestedInStake: props.data.interestedInStake || undefined,
        interestedInTopJobsharing: props.data.interestedInTopJobsharing || undefined
      },
      isOnline: props.data.isOnline,
      onlineSince: props.data.onlineSince,
      amountMatched: props.data.amountMatched,
      amountMatchedWithCandidateEntry: props.data.amountMatchedWithCandidateEntry,
      selectedWorkField: 'none',
      showProjectMatchingFormWorkFieldSelectionPopUp: false
    };
    this.allFormFieldKeys = Object.keys(this.state.formFields);
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  handleCloseProjectMatchingFormWorkFieldSelectionPopUp(clickedWorkField) {
    this.setState(prevState => {
      const prevWorkFields = prevState.formFields.workFields;
      const newWorkFields = prevWorkFields.slice();

      // duplicate check / prevents double click
      const isAlreadySelected = prevWorkFields.some(el => {
        const foundDuplicate = el.key === clickedWorkField.key;
        return foundDuplicate;
      });

      // add in case no duplicate
      if (!isAlreadySelected) newWorkFields.push(clickedWorkField);

      return {
        formFields: {
          ...prevState.formFields,
          workFields: newWorkFields
        },
        showProjectMatchingFormWorkFieldSelectionPopUp: false,
        selectedWorkField: 'none'
      };
    });
  }

  getInitialSalaryKey = () => {
    const salary = Number(this.props.data.salary);
    if (!salary) return undefined;

    const options = this.props.inCandiateArchive ? salaryCheckBoxOptionsCandidate : salaryCheckBoxOptionsProject;

    const matched = [...options].reverse().find(option => salary >= option.key);

    return matched ? matched.key : undefined;
  };

  componentDidMount() {
    const salaryKey = this.getInitialSalaryKey();

    this.setState(prevState => ({
      formFields: {
        ...prevState.formFields,
        salary: salaryKey
      }
    }));
  }

  removeCurrentWorkFieldFormWorkFieldSelectionPopUp(workFieldKeyToBeRemoved) {
    this.setState(prevState => {
      const newWorkField = prevState.formFields.workFields.slice();
      const filterdWorkFields = newWorkField.filter(workFields => workFields.key !== workFieldKeyToBeRemoved);
      return {
        formFields: {
          ...prevState.formFields,
          workFields: filterdWorkFields
        },
        showProjectMatchingFormWorkFieldSelectionPopUp: false,
        selectedWorkField: 'none'
      };
    });
  }

  validateCheckBoxSelection(checkBoxFormId) {
    let isValid = false;
    if (checkBoxFormId === 'hierarchy') {
      // allow max 2 check box checked
      if (this.state.formFields.hierarchy.length < 3) isValid = true;
    } else isValid = true;
    return isValid;
  }

  handleRadioChange = (checkBoxFormId, checkBoxId) => {
    this.setState(prevState => {
      const updatedState = {
        ...prevState.formFields,
        [checkBoxFormId]: checkBoxId
      };
      return { formFields: updatedState };
    });
  };

  handleCheckBoxChange = (checkBoxFormId, checkBoxId) => {
    this.setState(prevState => {
      let dropDownSelection = prevState.formFields[checkBoxFormId].slice();
      // special case for selection of all regions
      if (checkBoxFormId === 'region' && checkBoxId === 'Ganze Schweiz') {
        if (dropDownSelection.includes(checkBoxId)) dropDownSelection = [];
        else dropDownSelection = regionCheckBoxOptions;
      }
      // case: checkBox has been already checked
      else if (dropDownSelection.includes(checkBoxId)) {
        // remove checked option
        const index = dropDownSelection.indexOf(checkBoxId);
        dropDownSelection.splice(index, 1);
      }

      // add checked option in case validation is passed (e.g. limit of allowed selected checkboxes)
      else if (this.validateCheckBoxSelection(checkBoxFormId)) dropDownSelection.push(checkBoxId);
      const updatedState = {
        ...prevState.formFields,
        [checkBoxFormId]: dropDownSelection
      };
      return { formFields: updatedState };
    });
  };

  handleSelectedSalaryKey = () => {
    const { salary } = this.state.formFields;

    if (salary === undefined) return undefined;

    const matchedOption = salaryCheckBoxOptionsProject.find(option => salary <= option.key);

    return matchedOption.key;
  };

  handleDropDownChange = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(prevState => {
      const originalLanguageState = prevState.formFields.languageSkills;

      // deep clone of original languageSkills state
      let newLanguageState = originalLanguageState
        // .slice()
        .map(l => Object.assign({}, l));

      const languageState = newLanguageState[index];
      languageState[name] = value;

      if (name === 'languageName') {
        // remove empty languageName fields
        newLanguageState = removeEmptyLanguageEntriesFromArray(newLanguageState);

        // remove duplicates
        let duplicateFound = false;
        newLanguageState = newLanguageState.filter(item =>
          // check if new value exist already in original languageState
          {
            const isDuplicate = originalLanguageState.some(originalEl => originalEl.languageName === value && item.languageName === value);
            const keepLanguage = duplicateFound || !isDuplicate;
            if (isDuplicate) duplicateFound = true;
            return keepLanguage;
          }
        );

        // add new empty row
        newLanguageState.push({
          languageName: '',
          languageLevel: ''
        });
      }

      // set updated state for languageSkills formFields
      return {
        formFields: {
          ...prevState.formFields,
          languageSkills: newLanguageState
        }
      };
    });
  };

  handleSectorDropDownChange = (e, index) => {
    const value = e.target.value;

    this.setState(prevState => {
      const sectorState = prevState.formFields.sector;
      sectorState[index] = value;

      // remove all empty dropDowns
      const trimmedArr = removeEmptyStringsFromArray(sectorState);

      // remove duplicates
      const newSectorState = trimmedArr.filter((item, pos) => trimmedArr.indexOf(item) === pos);

      // add empty dropDown
      newSectorState.push('');
      return {
        formFields: { ...prevState.formFields, sector: newSectorState }
      };
    });
  };

  mapLanguageSkills(languageArr) {
    const mappedLanguageSkills = [];
    if (Array.isArray(languageArr))
      languageArr.forEach(languageSkills => {
        if (languageSkills.languageName) mappedLanguageSkills.push(languageSkills);
      });
    return mappedLanguageSkills;
  }

  updateProjectMatchingAPICall(updatedData) {
    let isOnline;
    let onlineSince;
    if (!this.props.data.isOnline && this.state.isOnline) {
      isOnline = true;
      onlineSince = new Date();
    }
    if (this.props.data.isOnline && !this.state.isOnline) {
      isOnline = false;
    }

    this.setState({ showLoadingIndicator: true });
    const requestBody = {
      projectId: this.props.selectedProjectId,
      updateData: {
        matching: {
          hierarchy: removeEmptyStringsFromArray(updatedData.hierarchy),
          region: updatedData.region,
          salary: updatedData.salary,
          languageSkills: this.mapLanguageSkills(updatedData.languageSkills),
          workFields: updatedData.workFields,
          sector: removeEmptyStringsFromArray(updatedData.sector),
          isOnline,
          onlineSince,
          partTimeFrom: updatedData.partTimeFrom,
          partTimeTill: updatedData.partTimeTill,
          interestedInStake: updatedData.interestedInStake,
          interestedInTopJobsharing: updatedData.interestedInTopJobsharing
        }
      }
    };
    const url = CONSTANTS.updateProjectURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      data: JSON.stringify(requestBody),
      timeout: CONFIG.ajaxTimeout
    })
      .done(responseBody => {
        console.log('🚀 ~ ProjectMatchingForm ~ updateProjectMatchingAPICall ~ responseBody:', responseBody);
        if (responseBody.status === 'no_job_posting_found') {
          this.props.handleSnackbarOpen('Die Anzeige ist noch nicht online, bitte versuchen Sie es später nochmals');
        } else {
          this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.updateSuccess);
        }
        if (onlineSince) this.setState({ onlineSince });
        this.setState({ showLoadingIndicator: false });
      })
      .fail(err => {
        if (err.responseJSON && err.responseJSON.resource === 'bitlinks') {
          this.props.handleSnackbarOpen('URL konnte nicht gekürzt werden. E-Mails und SMS wurden nicht verschickt.');
        } else {
          this.errorHandling(err, url);
        }
        this.setState({ showLoadingIndicator: false });
      });
  }

  getUpdateData(key) {
    // // special case for dropDowns with key value pairs
    // if (typeof initialValue === 'object')
    //   initialValue = this.props.initialData[key].id;

    let currentValue;
    // case inputField
    if (this.state.formFields[key]) currentValue = this.state.formFields[key];
    // case dropDowns
    else currentValue = this.state.formFields[key];

    // TODO impl. later with changeHistory
    // if (initialValue !== currentValue) {
    // handle case initialValue and currentValue both undefined, empty or null
    // if (initialValue || currentValue)
    const result = currentValue;
    // }
    return result;
  }

  generateUpdateData() {
    const updatedData = {};
    this.allFormFieldKeys.forEach(fieldKey => {
      const updatedValue = this.getUpdateData(fieldKey);
      if (updatedValue !== undefined) {
        updatedData[fieldKey] = updatedValue;
      }
    });
    return updatedData;
  }

  updateData() {
    const updatedData = this.generateUpdateData();
    if (this.props.customSubmit)
      this.props.customSubmit({
        matching: {
          hierarchy: updatedData.hierarchy,
          region: updatedData.region,
          salary: updatedData.salary && updatedData.salary,
          languageSkills: this.mapLanguageSkills(updatedData.languageSkills),
          workFields: updatedData.workFields,
          sector: removeEmptyStringsFromArray(updatedData.sector),
          partTimeFrom: updatedData.partTimeFrom,
          partTimeTill: updatedData.partTimeTill,
          interestedInStake: updatedData.interestedInStake,
          interestedInTopJobsharing: updatedData.interestedInTopJobsharing
        }
      });
    else this.updateProjectMatchingAPICall(updatedData);
  }

  handleSubmitButtonClick = e => {
    e.preventDefault();
    const formFields = this.state.formFields;

    if (
      this.props.inMatchingSearch ||
      (formFields.hierarchy &&
        formFields.hierarchy.length > 0 &&
        formFields.region &&
        formFields.region.length > 0 &&
        formFields.salary &&
        formFields.languageSkills &&
        formFields.languageSkills.length > 0 &&
        formFields.workFields &&
        formFields.workFields.length > 0 &&
        formFields.sector &&
        formFields.sector.length > 0)
    ) {
      this.updateData();
    } else {
      this.props.handleSnackbarOpen('Bitte füllen Sie alle Felder aus. Ihre Daten wurden nicht gespeichert.');
    }
  };

  renderLanguageDropDowns() {
    return (
      <div className="col-4">
        <Tooltip title="Es muss mindestens eine Muttersprache gewählt werden">
          <FormLabel htmlFor="Sprachkenntnisse">Sprachkenntnisse</FormLabel>
        </Tooltip>
        {this.state.formFields.languageSkills.map((languageSkills, index) => (
          <div className="row">
            <div className="col-6">
              <ValidatedDropDown
                id="languageName"
                // ref={this.formFieldRefs[index]}
                content={languageNameDropDownOptions}
                // label=""
                onChange={e => this.handleDropDownChange(e, index)}
                value={languageSkills.languageName}
                furtherPropsSelect={{
                  fullWidth: true,
                  disabled: this.props.inCandiateArchive
                }}
                // {...this.state.inputFields.country}
              />
            </div>
            <div className="col-6">
              <ValidatedDropDown
                id="languageLevel"
                // ref={this.formFieldRefs[index]}
                content={languageSkillLevelDropDownOptions}
                // label=""
                onChange={e => this.handleDropDownChange(e, index)}
                value={languageSkills.languageLevel}
                furtherPropsSelect={{
                  fullWidth: true,
                  disabled: this.props.inCandiateArchive
                }}
                // {...this.state.inputFields.country}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderWorkFieldSelection() {
    const workFields = this.state.formFields.workFields.slice();
    const placeHolderText = 'Tätigkeitsfeld hinzufügen';
    if (!workFields.includes(placeHolderText)) workFields.push(placeHolderText);
    return (
      <div className="col-4">
        <FormLabel htmlFor="Ausrichtung / Wunschtätigkeit">Ausrichtung / Wunschtätigkeit</FormLabel>
        {workFields.map(workField => {
          const workFieldName = typeof workField === 'string' ? workField : workField.value;

          return (
            // <div className="row">
            //   <div className="col-6">
            <Button
              id="workFields"
              fullWidth
              classes={workFieldName !== placeHolderText ? { text: 'text-transform-none' } : {}}
              color={workFieldName !== placeHolderText ? 'default' : 'primary'}
              disabled={this.props.inCandiateArchive}
              onClick={() =>
                this.setState({
                  selectedWorkField: workField.key,
                  showProjectMatchingFormWorkFieldSelectionPopUp: true
                })
              }
            >
              {workFieldName}
            </Button>
            //   </div>
            // </div>
          );
        })}
      </div>
    );
  }

  renderSectorDropDowns() {
    return (
      <div className="col-4">
        <FormLabel htmlFor="Branchen">Branchen</FormLabel>
        {this.state.formFields.sector.map((sector, index) => (
          <ValidatedDropDown
            id="sector"
            // ref={this.formFieldRefs[index]}
            content={sectorDropDownOptions}
            // label=""
            onChange={e => this.handleSectorDropDownChange(e, index)}
            value={sector}
            furtherPropsSelect={{
              fullWidth: true,
              disabled: this.props.inCandiateArchive
            }} // {...this.state.inputFields.country}
          />
        ))}
      </div>
    );
  }

  renderSaveButton = () => (
    <div className="col-4 offset-4 mt-5 text-center">
      <Button
        onClick={this.handleSubmitButtonClick}
        variant="contained"
        type="submit"
        color="primary"
        fullWidth
        disabled={this.state.showLoadingIndicator}
      >
        <CircularProgress
          size={20}
          style={{ display: this.state.showLoadingIndicator ? 'block' : 'none', color: 'grey', marginRight: '5px' }}
        />
        {this.props.inMatchingSearch ? 'Suchen' : 'Speichern'}
      </Button>
    </div>
  );

  render() {
    return (
      <div className="container">
        <div className="row pt-5 pb-5 pl-2 pr-2">
          {!this.props.inCandiateArchive && !this.props.inMatchingSearch && (
            <React.Fragment>
              <div className="col-2">
                <p className="projectDetailLabel">Aktiv seit:</p>
                <p>{this.state.onlineSince && UTILS.formatDateToDELocale(new Date(this.state.onlineSince))}</p>
              </div>
              <div className="col-2">
                <FormControlLabel
                  control={
                    <Switch
                      onChange={() => {
                        this.setState(prevState => ({
                          isOnline: !prevState.isOnline
                        }));
                      }}
                      value="matchingIsOnline"
                      checked={this.state.isOnline}
                      color="primary"
                    />
                  }
                  label="Matching Aktiv"
                />
              </div>
              <div className="col-8">
                <div className="row">
                  <div className="col-4">
                    <p className="projectDetailLabel">Anzahl Matchingprofile:</p>
                    <p>{this.state.amountMatched ? this.state.amountMatched : ''}</p>
                  </div>
                  <div className="col-4">
                    <p className="projectDetailLabel">Matchingprofile mit Kandidateneintrag:</p>
                    <Link to={`matchingProfiles?pid=${this.props.selectedProjectId}`}>
                      {this.state.amountMatchedWithCandidateEntry ? this.state.amountMatchedWithCandidateEntry : ''}
                    </Link>
                  </div>
                  <div className="col-4">
                    <p className="projectDetailLabel">Anzahl Kandidatenprofile:</p>
                    <Link to={`applicantUser?pid=${this.props.selectedProjectId}`}>
                      {this.state.amountMatched && this.state.amountMatchedWithCandidateEntry
                        ? this.state.amountMatched - this.state.amountMatchedWithCandidateEntry
                        : ''}
                    </Link>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className="col-12 mb-2 ">
            <CheckBoxes
              id="hierarchy"
              sectionLabel="Hierarchiestufe"
              options={hierarchyCheckBoxOptions}
              handleCheckBoxChange={this.handleCheckBoxChange}
              checked={this.state.formFields.hierarchy}
              layoutHorizontal
              disabled={this.props.inCandiateArchive}
            />
          </div>
          <div className="col-12 mb-2">
            <CheckBoxes
              id="region"
              sectionLabel="Arbeitsregionen"
              options={this.props.inCandiateArchive ? regionCheckBoxOptionsCandidate : regionCheckBoxOptions}
              handleCheckBoxChange={this.handleCheckBoxChange}
              checked={this.state.formFields.region}
              layoutHorizontal
              disabled={this.props.inCandiateArchive}
            />
          </div>
          <div className="col-12 mb-2">
            <RadioButtons
              id="salary"
              sectionLabel="Salär Bandbreite"
              options={this.props.inCandiateArchive ? salaryCheckBoxOptionsCandidate : salaryCheckBoxOptionsProject}
              handleChange={this.handleRadioChange}
              selected={this.state.formFields.salary}
              layoutHorizontal
              disabled={this.props.inCandiateArchive}
            />
          </div>
          {this.renderLanguageDropDowns()}
          {this.renderWorkFieldSelection()}
          {this.renderSectorDropDowns()}
          <div className="col-6 mt-3">
            <div className="row">
              <div className="col-12">
                <FormLabel htmlFor="Branchen">Zusätzliche Optionen</FormLabel>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <FormControlLabel
                  className="checkBoxArea"
                  disabled={this.props.inCandiateArchive}
                  control={
                    <Checkbox
                      className="checkBox"
                      checked={this.state.formFields.interestedInStake}
                      onChange={() => {
                        this.setState(prevState => ({
                          formFields: {
                            ...prevState.formFields,
                            interestedInStake: !prevState.formFields.interestedInStake
                          }
                        }));
                      }}
                      disabled={this.props.inCandiateArchive}
                    />
                  }
                  label="Interessiert an finanzieller Beteiligung"
                />
              </div>
              <div className="col-12">
                <FormControlLabel
                  className="checkBoxArea"
                  disabled={this.props.inCandiateArchive}
                  control={
                    <Checkbox
                      className="checkBox"
                      checked={this.state.formFields.interestedInTopJobsharing}
                      onChange={() => {
                        this.setState(prevState => ({
                          formFields: {
                            ...prevState.formFields,
                            interestedInTopJobsharing: !prevState.formFields.interestedInTopJobsharing
                          }
                        }));
                      }}
                      disabled={this.props.inCandiateArchive}
                    />
                  }
                  label="Interessiert an Top-/Jobsharing"
                />
              </div>
            </div>
          </div>
          <div className="col-6 mt-3 mb-3">
            <div className="row">
              <div className="col-12">
                <FormLabel htmlFor="partTimeFrom">Pensum</FormLabel>
              </div>
              <div className="col-6">
                <TextField
                  id="partTimeFrom"
                  disabled={this.props.inCandiateArchive}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">von</InputAdornment>,
                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                  }}
                  value={this.state.formFields.partTimeFrom}
                  type="number"
                  onChange={event => {
                    const value = event.target.value;
                    this.setState(prevState => ({
                      formFields: {
                        ...prevState.formFields,
                        partTimeFrom: value
                      }
                    }));
                  }}
                />
              </div>
              <div className="col-6">
                <TextField
                  id="partTimeTill"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">bis</InputAdornment>,
                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                  }}
                  value={this.state.formFields.partTimeTill}
                  type="number"
                  disabled={this.props.inCandiateArchive}
                  onChange={event => {
                    const value = event.target.value;
                    this.setState(prevState => ({
                      formFields: {
                        ...prevState.formFields,
                        partTimeTill: value
                      }
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          {!this.props.inCandiateArchive && this.renderSaveButton()}

          {/* PopUps */}
          <ProjectMatchingFormWorkFieldSelectionPopUp
            key={this.state.selectedWorkField || 'defaultKey'}
            open={this.state.showProjectMatchingFormWorkFieldSelectionPopUp}
            selectedWorkField={this.state.selectedWorkField}
            handleClose={clickedWorkField => this.handleCloseProjectMatchingFormWorkFieldSelectionPopUp(clickedWorkField)}
            removeCurrentWorkFieldFormWorkFieldSelectionPopUp={clickedWorkField =>
              this.removeCurrentWorkFieldFormWorkFieldSelectionPopUp(clickedWorkField)
            }
          />
        </div>
      </div>
    );
  }
}
ProjectMatchingForm.defaultProps = {
  data: {},
  inCandiateArchive: false,
  selectedProjectId: '',
  inMatchingSearch: false,
  customSubmit: undefined
};

ProjectMatchingForm.propTypes = {
  handleSnackbarOpen: PropTypes.func.isRequired,
  selectedProjectId: PropTypes.string,
  data: PropTypes.object,
  inCandiateArchive: PropTypes.bool,
  inMatchingSearch: PropTypes.bool,
  customSubmit: PropTypes.func
};

export default ProjectMatchingForm;
